import { http } from '@frontend/fetch';
import type {
  TrueLarkLocationResponse,
  TrueLarkSubscriptionResponse,
  TrueLarkBusinessDetails,
  UpdateSubscriptionRequest,
  BusinessPlanDetails,
  TrueLarkDomains,
  TrueLarkPlansResponse,
  UpdateBusinessPlanRequest,
} from './types';

export const searchLocations = (queryTerm: string) =>
  http.get<TrueLarkLocationResponse>('truelark/wam/v1/location', {
    params: { query_term: queryTerm },
    skipValidation: true,
  });

export const getSubscriptionStatus = (locationId: string) =>
  http.get<TrueLarkSubscriptionResponse>(`truelark/wam/v1/location/${locationId}/subscription:status`, {
    skipValidation: true,
  });

export const updateSubscriptionStatus = (locationId: string, body: UpdateSubscriptionRequest) =>
  http.post<void, UpdateSubscriptionRequest>(`truelark/wam/v1/location/${locationId}/subscription:updateStatus`, body, {
    skipValidation: true,
  });

export const getBusinessDetails = (locationId: string) =>
  http.get<TrueLarkBusinessDetails>(`truelark/wam/v1/location/${locationId}/details`, {
    skipValidation: true,
  });

export const getActiveBusinessPlan = (locationId: string) =>
  http.get<BusinessPlanDetails>(`truelark/wam/v1/location/${locationId}/plan:active`, {
    skipValidation: true,
  });

export const getBusinessPlans = (domain: TrueLarkDomains) =>
  http.get<TrueLarkPlansResponse>(`truelark/wam/v1/plans/${domain}?business_type=BUSINESS_TYPE_TRUELARK`, {
    skipValidation: true,
  });

export const updateBusinessPlan = (body: UpdateBusinessPlanRequest) =>
  http.post<void, UpdateBusinessPlanRequest>(`truelark/wam/v1/location/plan:update`, body, {
    skipValidation: true,
  });
